module.exports = __webpack_public_path__ + "img/edit.2214e4a4.svg";